// Project-wide date formatting helpers (DD-MM-YYYY)

function parseLoose(input: string | Date | null | undefined): Date | null {
  if (!input) {return null;}
  if (input instanceof Date) {return isNaN(input.getTime()) ? null : input;}
  const s = String(input).trim();
  if (!s) {return null;}
  // DD-MM-YYYY or DD/MM/YYYY
  const dmy = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})$/);
  if (dmy) {
    const [, d, m, y] = dmy;
    let yr = parseInt(y); if (yr < 100) {yr += 2000;}
    const dt = new Date(Date.UTC(yr, parseInt(m) - 1, parseInt(d)));
    return isNaN(dt.getTime()) ? null : dt;
  }
  // ISO YYYY-MM-DD or full ISO timestamp
  const dt = new Date(s);
  return isNaN(dt.getTime()) ? null : dt;
}

/** Format any date input as DD-MM-YYYY. Returns "" for invalid/empty. */
export function formatDate(input: string | Date | null | undefined): string {
  const dt = parseLoose(input);
  if (!dt) {return "";}
  const d = String(dt.getUTCDate()).padStart(2, "0");
  const m = String(dt.getUTCMonth() + 1).padStart(2, "0");
  const y = dt.getUTCFullYear();
  return `${d}-${m}-${y}`;
}

/** DD-MM-YYYY HH:mm */
export function formatDateTime(input: string | Date | null | undefined): string {
  const dt = parseLoose(input);
  if (!dt) {return "";}
  const base = formatDate(dt);
  const hh = String(dt.getHours()).padStart(2, "0");
  const mm = String(dt.getMinutes()).padStart(2, "0");
  return `${base} ${hh}:${mm}`;
}
